import React from 'react';
import cn from 'classnames';

import VIDEO_TUT from 'assets/videos/Email_Marketing_Flow_v1.mp4';
import ExternalLink from 'components/generic/ExternalLink.component';
import Icon from 'components/generic/Icon.component';
import Video from 'components/generic/Video.component';
import CurrencySign from 'components/price/CurrencySign.component';
import { useTheme } from 'providers/Theme.provider';

import CN from './EmailsInfo.module.scss';

const LINK_HOW_TO_START = 'https://help.getslick.com/en/articles/12975056-slick-email-quick-guide';
const LINK_DESIGN_EMAILS = 'https://help.getslick.com/en/articles/12975570-how-to-design-emails-on-slick-email';

const DATA_INFO_FIRST = [
  <div>
    <div className={CN.point}>
      <Icon variant="checkCircle" width="md" />
      Design in minutes using templates and drag & drop
    </div>
    <div className={CN.point}>
      <Icon variant="checkCircle" width="md" />
      <div>
        <span className={CN.bold}>Your first email blast is free </span>
        - then <CurrencySign />
        0.02/email + VAT
      </div>
    </div>
    <div className={CN.point}>
      <Icon variant="checkCircle" width="md" />
      Track clicks, bookings and revenue back in Slick
    </div>

    <div className={CN.linkContainer}>
      <ExternalLink tag="EmailsInfo__link" link={LINK_HOW_TO_START}>
        <span className={CN.articleLink}>How to Start</span>
      </ExternalLink>
      <ExternalLink tag="EmailsInfo__link" link={LINK_DESIGN_EMAILS}>
        <span className={CN.articleLink}>Templates</span>
      </ExternalLink>
    </div>
  </div>,
];

const VIDEO_TITLE = 'Email Marketing Flow ';

const EmailsInfo = () => {
  const { isDarkMode } = useTheme();

  return (
    <div
      data-bem="EmailsInfo"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.container}>
        <div data-bem="EmailsInfo__video" className={CN.infoVideo}>
          <Video src={VIDEO_TUT} title={VIDEO_TITLE} variant="full" />
        </div>
        <div data-bem="EmailsInfo__info" className={CN.infoBlock}>
          <div className={CN.infoTitle}>Boost bookings with Slick Email</div>
          {DATA_INFO_FIRST}
        </div>
      </div>
    </div>
  );
};

export default EmailsInfo;
